/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SetupRouteImport } from './routes/setup'
import { Route as ModerationRouteImport } from './routes/moderation'
import { Route as DashboardRouteImport } from './routes/dashboard'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthEntraCallbackRouteImport } from './routes/auth/entra-callback'

const SetupRoute = SetupRouteImport.update({
  id: '/setup',
  path: '/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const ModerationRoute = ModerationRouteImport.update({
  id: '/moderation',
  path: '/moderation',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthEntraCallbackRoute = AuthEntraCallbackRouteImport.update({
  id: '/auth/entra-callback',
  path: '/auth/entra-callback',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/dashboard': typeof DashboardRoute
  '/moderation': typeof ModerationRoute
  '/setup': typeof SetupRoute
  '/auth/entra-callback': typeof AuthEntraCallbackRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/dashboard': typeof DashboardRoute
  '/moderation': typeof ModerationRoute
  '/setup': typeof SetupRoute
  '/auth/entra-callback': typeof AuthEntraCallbackRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/dashboard': typeof DashboardRoute
  '/moderation': typeof ModerationRoute
  '/setup': typeof SetupRoute
  '/auth/entra-callback': typeof AuthEntraCallbackRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/moderation'
    | '/setup'
    | '/auth/entra-callback'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/dashboard'
    | '/moderation'
    | '/setup'
    | '/auth/entra-callback'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/dashboard'
    | '/moderation'
    | '/setup'
    | '/auth/entra-callback'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  DashboardRoute: typeof DashboardRoute
  ModerationRoute: typeof ModerationRoute
  SetupRoute: typeof SetupRoute
  AuthEntraCallbackRoute: typeof AuthEntraCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/setup': {
      id: '/setup'
      path: '/setup'
      fullPath: '/setup'
      preLoaderRoute: typeof SetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/moderation': {
      id: '/moderation'
      path: '/moderation'
      fullPath: '/moderation'
      preLoaderRoute: typeof ModerationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/entra-callback': {
      id: '/auth/entra-callback'
      path: '/auth/entra-callback'
      fullPath: '/auth/entra-callback'
      preLoaderRoute: typeof AuthEntraCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  DashboardRoute: DashboardRoute,
  ModerationRoute: ModerationRoute,
  SetupRoute: SetupRoute,
  AuthEntraCallbackRoute: AuthEntraCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
